import React from 'react';

const SuccessModal = ({ show, onHide, registrationData }) => {
    if (!show) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0 text-center">
                        <div className="w-100">
                            <div className="success-icon">
                                <i className="fas fa-check"></i>
                            </div>
                            <h3 className="text-success mb-0">Registration Successful!</h3>
                        </div>
                        <button type="button" className="btn-close" onClick={onHide}></button>
                    </div>

                    <div className="modal-body px-5 pb-5">
                        <div className="text-center mb-4">
                            <h5 className="text-success mb-3">Welcome to Dominion City PH Skills Acquisition Program!</h5>
                            <p className="text-muted">
                                Your registration has been submitted successfully. You will receive confirmation
                                emails and SMS messages shortly.
                            </p>
                        </div>

                        {registrationData && (
                            <div className="card mb-4">
                                <div className="card-header bg-primary text-white">
                                    <h6 className="mb-0"><i className="fas fa-id-card me-2"></i>Your Registration Details</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p><strong>Registration ID:</strong></p>
                                            <p className="h5 text-primary font-monospace">{registrationData.registrationId}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <p><strong>Email:</strong> {registrationData.email}</p>
                                            <p><strong>Skill:</strong> {registrationData.skillOfInterest}</p>
                                            <p><strong>Status:</strong>
                                                <span className="badge bg-primary ms-2">Approved</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/*<div className="alert alert-info">*/}
                        {/*    <h6><i className="fas fa-clock me-2"></i>What happens next?</h6>*/}
                        {/*    <ul className="mb-0">*/}
                        {/*        <li>Your application will be reviewed within <strong>2-3 business days</strong></li>*/}
                        {/*        <li>You will receive email and SMS notifications about your application status</li>*/}
                        {/*        <li>If approved, you will receive detailed training schedule and materials</li>*/}
                        {/*        <li>Keep your Registration ID safe for future reference</li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}

                        <div className="alert alert-success">
                            <h6><i className="fas fa-envelope me-2"></i>Check Your Messages</h6>
                            <p className="mb-0">
                                Please check your email inbox for immediate confirmation.
                                Don't forget to check your spam/junk folder if you don't see our email.
                            </p>
                        </div>

                        <div className="text-center">
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100"
                                        onClick={() => window.print()}
                                    >
                                        <i className="fas fa-print me-2"></i>
                                        Print Details
                                    </button>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={onHide}
                                    >
                                        <i className="fas fa-check me-2"></i>
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer border-0 bg-light text-center">
                        <div className="w-100">
                            <p className="text-muted small mb-0">
                                <i className="fas fa-phone me-1"></i> Need help? Contact us at +234 123 456 7890
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;